<template>
  <transition name="product">
    <div class="ClueEntry">
      <van-nav-bar
        fixed
        title="项目查询"
        left-arrow
        @click-left="onClickLeft"
      />
      <b-row>
        <b-col md="12 mt-5 mb-30">
          <b-card>
            <b-row>
              <b-form-group
                class="col-md-6 mb-3"
                label="项目名称"
                label-for="input-1"
              >
                <b-form-input
                  v-model="form.ProjectName"
                  type="text"
                  required
                  placeholder="请输入项目名称"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="责任单位"
                label-for="input-1"
                class="col-md-6 mb-3"
                v-if="zrShow"
              >
                <b-form-select
                  v-model="zrCompanyId"
                  :options="zrOptions"
                  required
                  id="inline-form-custom-select-pref1"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                label="所属行业"
                label-for="input-1"
                class="col-md-6 mb-3"
              >
                <b-form-select
                  v-model="form.Canye"
                  :options="options5"
                  required
                  id="inline-form-custom-select-pref1"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                label="项目性质"
                label-for="input-1"
                class="col-md-6 mb-3"
              >
                <b-form-select
                  v-model="form.ProjectNature"
                  :options="options1"
                  required
                  id="inline-form-custom-select-pref1"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                label="项目状态"
                label-for="input-1"
                class="col-md-6 mb-3"
              >
                <b-form-select
                  v-model="form.Status"
                  :options="options3"
                  required
                  id="inline-form-custom-select-pref1"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                class="col-md-6 mb-3"
                label="联系人"
                label-for="input-1"
              >
                <b-form-input
                  v-model="form.Contact"
                  type="text"
                  required
                  placeholder="请输入联系人姓名"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                class="col-md-6 mb-3"
                label="企业名称"
                label-for="input-1"
              >
                <b-form-input
                  v-model="form.CompanyName"
                  type="text"
                  required
                  placeholder="请输入企业名称"
                ></b-form-input>
              </b-form-group>
              <b-col md="12 text-center">
                <b-button
                  class="mt-3 w-50 button-color"
                  @click="search(1)"
                  variant="primary"
                  >查询
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="search"
      >
        <b-row>
          <b-col cols="12" v-for="(item, index) in list" :key="index">
            <b-card
              style="width: 95%; margin: 0 auto"
              class="mt-3 card-icon-bg card-icon-bg-primary o-hidden"
              @click="onItemClick(item)"
            >
              <div class="content d-flex van-row--justify-space-between">
                <p class="card-title text-break">{{ item.projectName }}</p>
                <div class="d-flex card-title" style="align-items: center">
                  <van-tag
                    class="parmary-color text-nowrap"
                    style="margin: 0 10px"
                    >{{ item.natureName }}
                  </van-tag>
                  <van-tag class="parmary-color text-nowrap"
                    >{{ item.stausDescription }}
                  </van-tag>
                </div>
              </div>
              <div class="d-flex justify-content-between fontSize">
                <span>项目名称：{{ item.projectName }}</span>
                <span>{{ item.creationTime | format("YYYY-MM-DD") }}</span>
              </div>
              <div class="mt-2 fontSize d-flex">
                <div style="width: 18%" class="text-nowrap text-break">
                  项目概述：
                </div>
                <div style="width: 83%" class="text-monospace">
                  {{ item.projectDescription }}
                </div>
              </div>
              <div class="mt-2 fontSize d-flex van-row--justify-space-between">
                <div>{{ item.companyName }}</div>
                <div>{{ item.industry }}</div>
              </div>
              <div class="mt-2 fontSize">
                <div>联系人：{{ item.contactPerson }}</div>
                <div class="mt-2">联系电话：{{ item.contactNumber }}</div>
                <div style="float: right; margin-top: -24px" v-if="false">
                  <van-button
                    type="danger"
                    size="mini"
                    style="margin: 0 10px; padding: 2px 16px"
                    @click="onReject(item)"
                  >
                    驳回
                  </van-button>
                  <van-button
                    type="primary"
                    size="mini"
                    style="padding: 2px 16px"
                    @click="onAgree(item)"
                  >
                    同意
                  </van-button>
                </div>
              </div>
              <div v-if="item.status == 20">
                <div
                  class="
                    pt-2
                    border-top
                    fontSize
                    mt-2
                    border-bottom-dotted-gray-1
                  "
                >
                  <div>驳回原因：{{ item.reason }}</div>
                  <div>{{ item.creationTime }}</div>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </van-list>
      <van-dialog
        v-model="agreeShow"
        :title="`选择${name}`"
        show-cancel-button
        closeOnClickOverlay
        :beforeClose="agreeBeforeClose"
      >
        <div style="height: 100%">
          <div style="height: calc(100% - 49px)">
            <van-form ref="tableForm" :label-width="'64px'" :colon="true">
              <van-field
                v-model="agreeForm.value"
                name="value"
                :label="name"
                :rules="agreeFormRules.value"
                :required="true"
                :colon="true"
                :center="true"
                :clearable="true"
                :readonly="true"
                :clickable="true"
                :placeholder="`请选择${name}`"
                @click="onFieldClick({ type: 'value' })"
              >
              </van-field>
            </van-form>
          </div>
        </div>
      </van-dialog>
      <van-popup v-model="agreePicker" position="bottom">
        <van-picker
          show-toolbar
          :value-key="'text'"
          :columns="agreePickerList"
          @confirm="onConfirmPicker"
          @cancel="agreePicker = false"
        >
        </van-picker>
      </van-popup>
      <van-dialog
        v-model="show"
        title="驳回"
        show-cancel-button
        closeOnClickOverlay
        :beforeClose="doReject"
      >
        <div style="height: 100%">
          <div style="height: calc(100% - 49px)">
            <van-form ref="tableForm2" :label-width="'64px'" :colon="true">
              <van-field
                name="reson"
                v-model="rejectForm.reson"
                :rules="rejectFormRules.reson"
                rows="3"
                autosize
                label="驳回原因"
                type="textarea"
                maxlength="250"
                placeholder="请输入驳回原因"
                show-word-limit
              >
              </van-field>
            </van-form>
          </div>
        </div>
      </van-dialog>
    </div>
  </transition>
</template>

<script>
import zrcompany from "@/mixins/zrcompany";

export default {
  name: "InvestMent",
  mixins: [zrcompany],
  data() {
    return {
      options5: [
        { text: "请选择", value: "" },
        { text: "采矿业", value: "采矿业" },
        { text: "制造业", value: "制造业" },
        {
          text: "电力、热力、燃气及水生产供应业",
          value: "电力、热力、燃气及水生产供应业",
        },
        { text: "建筑业", value: "建筑业" },
        { text: "批发和零售业", value: "批发和零售业" },
        { text: "交通运输、仓储和邮政业", value: "交通运输、仓储和邮政业" },
        { text: "住宿和餐饮业", value: "住宿和餐饮业" },
        {
          text: "信息传输、软件和信息技术服务业",
          value: "信息传输、软件和信息技术服务业",
        },
        { text: "金融业", value: "金融业" },
        { text: "房地产业", value: "房地产业" },
        { text: "租赁和商务服务业", value: "租赁和商务服务业" },
        { text: "科学研究和技术服务业", value: "科学研究和技术服务业" },
        {
          text: "水利、环境和公共设施管理业",
          value: "水利、环境和公共设施管理业",
        },
        { text: "教育", value: "教育" },
        { text: "卫生和社会工作", value: "卫生和社会工作" },
        { text: "文化、体育和娱乐业", value: "文化、体育和娱乐业" },
        {
          text: "公共管理、社会保障和社会组织",
          value: "公共管理、社会保障和社会组织",
        },
        { text: "国际组织", value: "国际组织" },
        { text: "其他服务业", value: "其他服务业" },
      ],
      loading: false,
      finished: false,
      options1: [{ value: "", text: "请选择" }],
      options2: [{ value: "", text: "请选择" }],
      options3: [
        { value: "", text: "请选择" },
        { value: 0, text: "待分配经办人" },
        { value: 11, text: "待分配审核" },
        { value: 15, text: "分配已审核" },
        { value: 20, text: "驳回" },
        { value: 30, text: "已立项" },
        { value: 40, text: "二次洽谈确认" },
        { value: 50, text: "专家评估" },
        { value: 60, text: "分管领导审核" },
        { value: 61, text: "分管领导审核-征集部门意见" },
        { value: 62, text: "分管领导审核-上会" },
        { value: 70, text: "科室领导审核" },
        { value: 71, text: "科室领导审核-停止项目" },
        { value: 72, text: "科室领导审核-征集部门意见" },
        { value: 73, text: "科室领导审核-上会" },
        { value: 74, text: "科室领导审核-专家评估" },
        { value: 80, text: "征集财政司法等部门意见" },
        { value: 90, text: "主管领导审核-上会" },
        { value: 100, text: "上会/审签" },
        { value: 110, text: "签约落地" },
        { value: 120, text: "已签约" },
        { value: 130, text: "已停止" },
      ],
      list: [],
      form: {
        Status: "",
        //项目性质
        ProjectNature: "",
        //项目联系人
        Contact: "",
        //企业名称
        ProjectName: "",
        //所属行业
        industry: "",
        Canye: "",
        PageSize: 5,
        PageIndex: 0,
      },
      show: false,
      rejectForm: {
        processId: "",
        projectId: "",
        passed: "false",
        reson: "",
      },
      rejectFormRules: {
        reson: [
          {
            required: true,
            trigger: "onBlur",
          },
        ],
      },
      agreeShow: false,
      agreeForm: {
        id: "",
        value: "",
      },
      agreeFormRules: {
        value: [
          {
            required: true,
            trigger: "onBlur",
          },
        ],
      },
      agreePicker: false,
      agreePickerList: [],
      configTitle: {
        depart: "科室领导",
        master: "分管领导",
        leader: "主管领导",
        current: "当前经办人",
      },
      configType: {
        depart: "1",
        master: "2",
        leader: "3",
        current: "4",
      },
      configStatus: {
        // no = 不能操作，yes = 可以提交，depart = 选择科室领导，master = 选择分管领导，leader = 选择主管领导
        0: "no", // 待分配经办人
        11: "no", // 待分配审核
        15: "no", // 分配已审核
        20: "no", // 驳回
        30: "depart", // 已立项
        40: "no", // 二次洽谈确认
        50: "no", // 专家评估
        60: "leader", // 分管领导审核
        61: "no", // 分管领导审核-征集部门意见
        62: "leader", // 分管领导审核-上会
        70: "master", // 科室领导审核
        71: "no", // 科室领导审核-停止项目
        72: "no", // 科室领导审核-征集部门意见
        73: "no", // 科室领导审核-上会
        74: "no", // 科室领导审核-专家评估
        80: "master", // 征集财政司法等部门意见
        81: "leader", // 征集财政司法等部门意见
        82: "current", // 征集财政司法等部门意见
        90: "current", // 主管领导审核-上会
        100: "current", // 上会/审签
        110: "no", // 签约落地
        120: "no", // 已签约
        130: "no", //已停止
      },
      name: "",
    };
  },
  methods: {
    search(val) {
      if (val) {
        this.list = [];
        this.form.PageIndex = 0;
      }
      this.form.PageIndex += 1;
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      this.request({
        url: "/v1.0/ThePublic/getProjectList",
        method: "GET",
        params: {
          PageSize: this.form.PageSize,
          PageIndex: this.form.PageIndex,
          Status: this.form.Status,
          ProjectNature: this.form.ProjectNature,
          Contact: this.form.Contact,
          ProjectName: this.form.ProjectName,
          industry: this.form.industry,
          CheckStatus: "",
          Canye: this.form.Canye,
          zrCompanyId: this.zrCompanyId,
        },
      }).then((res) => {
        if (res.success) {
          res.data.items.map((item) => {
            this.list.push(item);
          });
          if (res.data.totalCount == this.list.length) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        }
        this.loading = false;
        this.$toast.clear();
      });
    },
    onRefresh() {
      this.form.PageIndex = 0;
      this.search();
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onReject(item) {
      this.show = true;
      this.rejectForm.projectId = item.id;
      this.rejectForm.reson = "";
      if (this.$refs.tableForm2) {
        this.$refs.tableForm2.resetValidation();
      }
    },
    doReject(action, done) {
      if (action === "confirm") {
        this.$refs.tableForm2
          .validate()
          .then((valid) => {
            // submit
            this.request({
              url: "/v1.0/Project/projectReturn",
              method: "post",
              data: this.rejectForm,
            })
              .then((res) => {
                done();
                this.onRefresh();
                this.$toast.clear();
              })
              .catch(() => {
                done();
                this.onRefresh();
              });
          })
          .catch((err) => {
            done(false);
          });
      } else {
        done();
      }
    },
    onAgree(item) {
      this.agreeForm.projectId = item.id;
      this.agreeForm.uid = "";
      this.agreeForm.value = "";
      if (this.$refs.tableForm) {
        this.$refs.tableForm.resetValidation();
      }
      this.getUserList(item.id, item.status);
    },
    onFieldClick(column) {
      this.agreePicker = true;
    },
    onConfirmPicker(val) {
      this.agreePicker = false;
      this.agreeForm.uid = val.value;
      this.agreeForm.value = val.text;
    },
    agreeBeforeClose(action, done) {
      if (action === "confirm") {
        this.$refs.tableForm
          .validate()
          .then((valid) => {
            // submit
            this.request({
              url: "/v1.0/Project/projectToCheckNew",
              method: "post",
              data: this.agreeForm,
            })
              .then((res) => {
                done();
                this.onRefresh();
                this.$toast.clear();
              })
              .catch(() => {
                done();
                this.onRefresh();
              });
          })
          .catch((err) => {
            done(false);
          });
      } else {
        done();
      }
    },
    getUserList(pid, status) {
      const selectType = this.getSelectType(status);
      this.name = this.getSelectTitle(status);
      if (selectType) {
        this.request({
          url: "/v1.0/User/getAuditUser",
          method: "GET",
          params: {
            Type: selectType,
            ProjectId: pid,
          },
        }).then((res) => {
          if (res.success) {
            if (res.data && res.data.length > 0) {
              this.agreeShow = true;
              this.agreePickerList = res.data;
              // 默认选择
              this.agreeForm.checkUserId = res.data[0].value;
              // this.options = [{value: "", text: `请选择${this.getSelectTitle}`}, ...res.data];
            }
          }
          this.$toast.clear();
        });
      }
    },
    getNextType(status) {
      const configStatus = this.configStatus;
      return configStatus[status + ""] || "no";
    },
    getSelectType(status) {
      return this.configType[this.getNextType(status)];
    },
    getSelectTitle(status) {
      return this.configTitle[this.getNextType(status)];
    },
    onItemClick(item) {
      this.$router.push(`/index/programDetail?id=${item.id}`);
    },
  },
  computed: {
    getUserId() {
      const userInfoStr = localStorage.getItem("userInfo");
      const userInfo = JSON.parse(userInfoStr || "{}");
      const { currentUser } = userInfo || {};
      const { id } = currentUser || {};
      return id;
    },
  },
  created() {
    this.request({
      url: "/v1.0/Clues/getCluesIndustryList",
      method: "GET",
      params: {},
    }).then((res) => {
      res.data.forEach((element) => {
        this.options2.push({ value: element, text: element });
      });
    });
    this.request({
      url: "/v1.0/Clues/getProjectNatureList",
      method: "GET",
      params: {},
    }).then((res) => {
      res.data.forEach((element) => {
        this.options1.push({ value: element.id, text: element.name });
      });
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";

.ClueEntry {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow-x: hidden;
  background-color: rgb(247, 248, 250);
  z-index: 1;
}
</style>
